import reactComponentLoader from 'scripts/react-component-loader'

import Modular from 'reactSite/Modular'

reactComponentLoader(Modular, '[data-modular-content]')
